// extracted by mini-css-extract-plugin
module.exports = {"body":"_50bd89e"};